export default __webpack_public_path__ + "static/media/postease-597-3x-new.1d590514.png";